import React from 'react';
import cn from 'classnames';
import { Spin } from 'antd';
import styles from './index.module.less';

type DefaultLoadingProps = {
    type?: 'page' | 'default';
}

const DefaultLoading: React.FC<DefaultLoadingProps> = props => {
    const { type = 'default' } = props;

    return (
        <div className={cn(styles.loading, styles[type], 'wrapper')}>
            <Spin/>
        </div>
    );
};

export default DefaultLoading;